import { isEntityParams, type NavigationParams } from '@/modules/Project/Navigation/navigationTypes'
import { useEntity } from '@/modules/Project/useEntity'
import { ref, watch } from 'vue'

/**
 * Represents the base project navigation logic
 *
 * Other parts of the application may use this as is, or may
 * encapsulate it, if logic specific to their context is needed.
 */
export function useProjectNavigator() {
  const entityStore = useEntity()

  const breadcrumbs = ref<NavigationParams[]>([])

  // should this be a watcher? or
  // should breadcrumbs be readonly and we handle this in navigate?
  watch(breadcrumbs, (crumbs) => {
    const last = crumbs.at(-1)
    const entityId = last?.entityId
    entityStore.setEntityId(entityId)
  })

  function navigate(params: NavigationParams) {
    const nextStack: NavigationParams[] = []
    if (isEntityParams(params)) {
      const projectParams = { ...params, entityId: undefined }
      nextStack.push(projectParams, params)
    } else {
      nextStack.push(params)
    }

    entityStore.setEntityId(params.entityId)
    breadcrumbs.value = nextStack
  }

  function reset() {
    breadcrumbs.value = []
    entityStore.setEntityId(undefined)
  }

  return { breadcrumbs, navigate, reset }
}
